import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from '../../utils';
import HighlightedNumber from '../HighlightedNumber';
import ChevronLeft from '../../icons/ChevronLeft';
import ChevronRight from '../../icons/ChevronRight';
import styles from './PageSelectControl.module.css';
import { JumpToBeginning, JumpToEnd } from '../../icons';
import { ViewportTypes, useViewportType } from '../../hooks';
const renderPageNumbers = (startPage, endPage, currentPage, pageCount, setPageNumber) => {
    let pageNumberLabels = [];
    for (let pageNumber = startPage; pageNumber <= endPage; pageNumber++) {
        const key = `pageNumberLabelClickable${pageNumber}`;
        if (pageNumber > endPage)
            break;
        let label;
        if (pageNumber === +currentPage) {
            label = (_jsx("div", Object.assign({ className: classNames(styles.pageNumber, styles.active), onClick: () => setPageNumber(pageNumber, 'pageNumber') }, { children: _jsx(HighlightedNumber, { value: pageNumber, color: "var(--accent-base)" }, void 0) }), key));
        }
        else {
            label = (_jsx("div", Object.assign({ className: styles.pageNumber, onClick: () => setPageNumber(pageNumber, 'pageNumber') }, { children: pageNumber }), key));
        }
        pageNumberLabels.push(label);
    }
    return pageNumberLabels;
};
const PageSelectControl = ({ hideFirstAndLastOptions, hidePageNumbers, pageCount, currentPage, setCurrentPage, }) => {
    const isMobile = useViewportType() === ViewportTypes.MOBILE;
    const renderCurrentPageNumber = isMobile
        ? `${currentPage} / ${pageCount}`
        : `Page ${currentPage} / ${pageCount}`;
    let pageNumberLabels = [];
    if (currentPage > pageCount) {
        setCurrentPage(1, 'first');
    }
    const canMoveNext = currentPage < pageCount;
    const canMovePrevious = currentPage > 1;
    if (pageCount < 5 || currentPage <= 3) {
        pageNumberLabels = renderPageNumbers(1, pageCount < 5 ? pageCount : 5, currentPage, pageCount, setCurrentPage);
    }
    else {
        const remainingPageCount = pageCount - currentPage;
        if (remainingPageCount < 2) {
            pageNumberLabels = renderPageNumbers(pageCount - 4, pageCount, currentPage, pageCount, setCurrentPage);
        }
        else {
            pageNumberLabels = renderPageNumbers(currentPage - 2, +currentPage + 2, currentPage, pageCount, setCurrentPage);
        }
    }
    const onMoveNext = () => {
        if (!canMoveNext)
            return;
        const nextPage = currentPage + 1;
        setCurrentPage(nextPage, 'next');
    };
    const onMovePrevious = () => {
        if (!canMovePrevious)
            return;
        const prevPage = currentPage - 1;
        setCurrentPage(prevPage, 'previous');
    };
    const onClickFirst = () => {
        setCurrentPage(1, 'first');
    };
    const onClickLast = () => {
        setCurrentPage(pageCount, 'last');
    };
    return (_jsxs("div", Object.assign({ className: styles.root }, { children: [!hideFirstAndLastOptions && (_jsx("div", Object.assign({ onClick: onClickFirst, className: classNames(styles.first, styles.chevronIcon, !canMovePrevious ? styles.disabled : '') }, { children: _jsx(JumpToBeginning, { size: 18 }, void 0) }), void 0)), _jsx("div", Object.assign({ onClick: onMovePrevious, className: classNames(styles.chevronIcon, styles.leftIcon, !canMovePrevious ? styles.disabled : '') }, { children: _jsx(ChevronLeft, { size: 18 }, void 0) }), void 0), hidePageNumbers ? (_jsx("span", Object.assign({ className: styles.pageNumberView }, { children: renderCurrentPageNumber }), void 0)) : (_jsx("div", Object.assign({ className: styles.pageNumberLabelsContainer }, { children: pageNumberLabels }), void 0)), _jsx("div", Object.assign({ onClick: onMoveNext, className: classNames(styles.chevronIcon, styles.rightIcon, !canMoveNext ? styles.disabled : '') }, { children: _jsx(ChevronRight, { size: 18 }, void 0) }), void 0), !hideFirstAndLastOptions && (_jsx("div", Object.assign({ onClick: onClickLast, className: classNames(styles.last, styles.chevronIcon, !canMoveNext ? styles.disabled : '') }, { children: _jsx(JumpToEnd, { size: 18 }, void 0) }), void 0))] }), void 0));
};
export default PageSelectControl;
